module.exports = __webpack_public_path__ + "img/videoResume.988193e4.svg";